import { render, staticRenderFns } from "./JobOverview.vue?vue&type=template&id=486e97fc"
import script from "./JobOverview.vue?vue&type=script&lang=js"
export * from "./JobOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports